import { action, observable, toJS, runInAction, computed } from "mobx";
import { getParameterByName } from "@utils/Browser";
import SearchStore from "../../Search/@stores/Search.store";

class SearchMapStore extends SearchStore {
	@observable geoCenter;
	@observable geoTopLeft;
	@observable geoBottomRight;
	@observable _pros = [];

	@observable _sidebarDisplay = true;
	@computed get sidebarDisplay() {
		return toJS(this._sidebarDisplay);
	}

	@computed get pros() {
		return toJS(this._pros);
	}

	get questions() {
		return super.questions;
	}

	get location() {
		return super.location;
	}

	get serviceKey() {
		return super.serviceKey;
	}

	get midtailKey() {
		return super.midtailKey;
	}

	get zipcode() {
		return super.zipcode;
	}

	get injectProId() {
		return getParameterByName("id");
	}

	get service() {
		return super.service;
	}

	constructor(...args) {
		super(...args);
		this.setGeo();
	}

	@action
	setSidebarDisplay(val) {
		this._sidebarDisplay = val;
	}

	@action
	setGeo() {
		this.geoCenter = this.getGeo("center");
		if (
			!this.geoCenter &&
			this.location?.lat &&
			this.location?.lng &&
			this.zipcode === this.location?.zip
		) {
			this.geoCenter = {
				lat: this.location.lat,
				lng: this.location.lng,
			};
		}

		this.geoBottomRight = this.getGeo("bottomRight");
		this.geoTopLeft = this.getGeo("topLeft");
	}

	getGeo(name) {
		const geo = getParameterByName(name);
		if (!geo) {
			return null;
		}

		const [lat, lng] = geo.split(",");
		return {
			lat: Number(lat),
			lng: Number(lng),
		};
	}

	@action
	async init() {
		this.setGeo();
		try {
			const { searchMapFilterQuestionStore } = this.rootStore.stores;
			const selections = searchMapFilterQuestionStore.selection;

			await super.redirectBasedOnAffinity();

			const geoBound = {
				...(this.geoTopLeft && this.geoBottomRight
					? { topLeft: this.geoTopLeft, bottomRight: this.geoBottomRight }
					: {}),
				...(this.geoCenter ? { center: this.geoCenter } : {}),
			};
			// const waitForSegment = () =>
			// 	new Promise((resolve) =>
			// 		analytics.ready(function () {
			// 			resolve(true);
			// 		})
			// 	);
			// await waitForSegment();
			// const user = await analytics.user();
			const { providers, filterQuestions, service, location } =
				await super.search({
					serviceKey: this.serviceKey || this.midtailKey,
					zipcode: this.zipcode,
					injectProId: this.injectProId,
					answerKeyFilters: selections || [""],
					geoBound,
					// anonymousId: user.anonymousId(),
					// userId: user.id(),
				});

			const account = await this.getAccount();

			runInAction(() => {
				this._pros = providers.map(({ provider, estimated_price }) => ({
					...provider,
					estimated_price,
				}));
				super._questions = filterQuestions;
				super._location = location;
				super._service = service;
				this.showSavvySlide =
					account?.provider?.claimed === false &&
					account.provider.track.source === "savvy";
				this.setGeo();
			});
		} catch (e) {
			throw e;
		}
	}
}

export default SearchMapStore;
